export default "__VITE_ASSET__CDErfCyG__"